const TASK_CREATED = 'tasks/created';

export const taskCreated = () => ({ type: TASK_CREATED });

export const taskUpdatesReducer = (state = 0, action) =>
    action.type === TASK_CREATED ? state + 1 : state;
